import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import "./B2BApprovalError.css";

const B2BApprovalError: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const error = searchParams.get("error");

  return (
    <div className="b2b-approval-result">
      <div className="b2b-approval-result-card">
        <div className="b2b-approval-result-icon error">
          <XCircle size={64} />
        </div>
        <h1 className="b2b-approval-result-title">Error</h1>
        <p className="b2b-approval-result-message">
          {error ? (
            <>
              <strong>Error:</strong> {decodeURIComponent(error)}
            </>
          ) : (
            "An error occurred while processing your request."
          )}
          <br />
          <br />
          This could happen if:
          <ul style={{ textAlign: "left", display: "inline-block", marginTop: "1rem" }}>
            <li>The approval link has expired (links expire after 7 days)</li>
            <li>The user has already been approved or rejected</li>
            <li>The link is invalid or has been used already</li>
          </ul>
        </p>
        <div className="b2b-approval-result-actions">
          <button
            onClick={() => navigate("/gcb/admin/dashboard")}
            className="b2b-approval-result-button"
          >
            Go to Admin Dashboard
          </button>
          <button
            onClick={() => navigate("/gcb")}
            className="b2b-approval-result-button secondary"
          >
            Back to GCB Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default B2BApprovalError;

